const HelperPopUpReducer = (state = {}, action: {showPopUp: any; type: string}) => {
  switch (action.type) {
    case "SHOW_POPUP":
      return Object.assign({}, state, {
        ShowPopUp: action.showPopUp
      })
    default:
      return state
  }
}

export default HelperPopUpReducer
